import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';

//import Typography from '@mui/material/Typography';
import {apipost,bizpost} from '../../../ajax';
import {BaseCard} from '../../../components/wizard';
import SendPanel from './SendPanel';
//import { extendedstyles } from '../../appstyles';
import { Box } from '@mui/material';

const s:any ={
  // progress: {
  //   m: '0 2',
  // },
  // spinner: {
  //   backgroundImage: 'url(lib/img/loading.gif)',
  //   backgroundSize: 'cover',
  //   backgroundRepeat: 'no-repeat',
  //   backgroundPosition: 'center',
  //   margin: 'auto',
  //   width: 40,
  //   height: 40,
  // },
  // note:{
  //   m: 1,
  // },
  // error: {
  //   color: '#ff0000',
  // }
};

class SendCard extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.props.deb.log("SendCard");
    this.state = {
      next: false,
      percent: 0,
      fwopen: false,
      error: false,
      status: 'Saving',
      loading:false,
    };
  }

  handleProgress = (ev:any,perc:any) => {
    this.setState({percent:perc});
  }

  // onSubmit = async() => {
  //   console.log('starting onSubmit... ');
  //   const {code,service,mode,sconfig,record,onResponse,ft,ms,mt} = this.props;
  //   const {url,endpoint} = sconfig || {};
  //   const {formData} = this.state;
  //   //console.log('onsubmit.formdata:',formData);
  //   try{
  //     let s = service;
  //     let a = mode;
  //     let recs = (mode==='delete')?{rid:+(record.rid),stp:record.stp}:record;
  //     let params = Object.assign(recs,formData,{s,a,ft,ms,mt});
  //     console.log('service request ',params);
  //     this.startLoading();
  //     var response;
  //     if(endpoint==='api')
  //       response = await apipost(url,code,params);
  //     else
  //       response = await bizpost(params);
  //     //console.log('service response ',response);

  //     if (response.success){
  //       this.props.showNotification(response.sm,'success',response.st)
  //       onResponse(true,response);
  //     }
  //     else if(response.failure){
  //       if (response.en===60){
  //       }
  //       else{
  //         this.props.showNotification(response.message,response.type||'error',response.title)
  //       }
  //     }      
  //   }
  //   catch(error){
  //     console.log('submitr.error:',error);
  //     this.props.showNotification(error.message||"request failed",error.type||'warn',error.title||'Update Error');

  //   }
  //   finally{
  //     this.stopLoading();
  //   }
  // }

  startLoading = () => {
    this.setState({loading:true});
  }

  stopLoading = () => {
    this.setState({loading:false});
  }

  //this method is designed for basecard.handleSend
  doSubmit = async() => {
    const { classes, theme, showNotification, ...extraProps } = this.props;  //fmtUI, logo, title, switchFn,
    const { record,data,extras,setItem } = this.props;
    const {data:formdata} = data;

    const {code,service,mode,sconfig,onResponse} = this.props;
    const {url,endpoint} = sconfig || {};
    //const {formData} = this.state;
    //console.log('onsubmit.formdata:',formData);
    try{
      this.startLoading();
      
      const s = 'bankapi';//service;
      const a = 'momolink';//mode;
      //let recs = (mode==='delete')?{rid:+(record.rid),stp:record.stp}:record;
      const params = {...formdata,s,a};
      console.log('service request ',params);

      const response = await bizpost(params);
      console.log('service response ',response);

      const {success,data:resdata} = response;

      if (success){
        showNotification(response.sm,'success',response.st)
        //onResponse(true,response);
        // "data": {
        //   "account": "0011020001003351",
        //   "title": "Samuel Kwame Torgbor",
        //   "currency": "GHS",
        //   "company": "GH0010001",
        //   "balance": "0",
        //   "type": "Cu",
        //   "actualbalance": "0",
        //   "product": "2"
        // },
        const {title:nam,currency:cur,type:atc,balance:bal} = resdata;
        console.log('found: ',nam,cur,bal,atc,data);
        const {data:olddata} = data;
        const newdata = {...olddata,nam};
        return response;
      }
      else {
        if (response.en===60){
        }
        else{
          const {message='Request Failed',type='error',title='Error'} = response;
          showNotification(message,type,title);
          return Promise.reject(response);
        }
      }      
    }
    catch(err){
      const error:any = (typeof err === 'object')?err:(typeof err === 'string')?{message:err}: {};
      console.log('submit.error:',JSON.stringify(error));
      //if(typeof err === 'object' && err !== null){
      try{
        const {data} = error;
        const {code,message,type='error',title="Error"} = data;
        showNotification(message,type,title);
        return Promise.reject(error.message);
      }
      catch(e){
        console.log('errorhandling error',e);
      }
      const {message="request failed",type='error',title='Error'} = error;
      showNotification(message,type,title);
      return Promise.reject(error.message);
    }
    finally{
      this.stopLoading();
    }
     
  }

  render = () => {
    const message = "Please review all the data provided before saving.";
    const { classes, theme, ...extraProps } = this.props;  //fmtUI, logo, title, switchFn,
    const { record,data,extras,setItem } = this.props;
    const { data:formdata } = data;
    const { loading } = this.state;
    //console.log('SENDCARD.record: ',record);
    //console.log('SENDCARD.formdata: ',formdata);
    return (
      <Box>
        <BaseCard
          cardid={'SEND'}
          cardname={'Send'}
          cardtitle={'Review'}
          instruction={'Please review all the data provided before saving customer'}
          step={2}
          buttons={['START','CANCEL','PREV','SEND','GUIDE']}
          doSubmit={this.doSubmit.bind(this)}
          {...extraProps}
          minHeight={300}
        >
          {/* <Typography>
            {message}
          </Typography> */}
          <SendPanel 
            id={'sendman'}
            //loaded={loaded}
            data={data}
            record={{...record,...formdata}} 
            extras={extras}
            loading={loading}
            // photo={photo} 
            // idcard={idcard}
            
            // print={print}
            // crop={crop}
            setItem={setItem}
          />
        </BaseCard>
      </Box>
    );
  }
}

SendCard.propTypes = {
  //classes: PropTypes.object.isRequired,
};

export default SendCard;
